import { BaseButton } from '@/components/common/base-button';
import PlaceHolder from '@/components/icons/shop/PlaceHolder';
import type { PoiContent } from '@/services/dto';
import { useConfigStore } from '@/stores';
import { getPoiListImageUrlFromContent } from '@/utils/poi/poiImage';
import clsx from 'clsx';
import { useMemo } from 'react';
import styles from './styles.module.scss';

type Props = {
    poiList?: PoiContent[];
    onSelectPoi?: (poi: PoiContent) => void;
    selectedPoiId?: string;
};
export const PoiListCarousel = ({ poiList, onSelectPoi, selectedPoiId }: Props) => {
    const language = useConfigStore((state) => state.config.ui.language);
    const isShowPoiList = useMemo(() => {
        if (!Array.isArray(poiList) || !poiList?.length) {
            return false;
        }
        return true;
    }, [poiList]);

    if (!isShowPoiList) {
        return null;
    }

    return (
        <div className={clsx(styles['poi-list-carousel'], 'scrollbar-hide')}>
            {Array.isArray(poiList) &&
                poiList?.map((poi, index) => {
                    const imageUrl = getPoiListImageUrlFromContent(poi, language);
                    const poiName = poi?.name?.[language] ?? poi?.name?.['ko'] ?? '';

                    return (
                    <BaseButton
                        data-modal-region={index === 0}
                        tabIndex={10}
                        data-interactive
                        key={poi?.id}
                        onClick={() => onSelectPoi?.(poi)}
                        className={clsx(styles['poi-list-carousel__item'], {
                            [styles['poi-list-carousel__item--selected']]: selectedPoiId === poi?.id,
                        })}
                    >
                        <div className={clsx(styles['poi-list-carousel__image'])}>
                            {imageUrl ? <img src={imageUrl} alt={poiName} loading="lazy" /> : <PlaceHolder />}
                        </div>
                        <div
                            className={clsx(styles['poi-list-carousel__name'], {
                                [styles['poi-list-carousel__name--selected']]: selectedPoiId === poi?.id,
                            })}
                        >
                            {(poi?.name?.[language] ? poi?.name?.[language] : poi?.name?.['ko']) || ''}
                        </div>
                        {selectedPoiId !== poi?.id && <div className={clsx(styles['poi-list-carousel__mask'])}></div>}
                    </BaseButton>
                    );
                })}
        </div>
    );
};
